import React from 'react';
import { ProductGallery } from '../components/ProductGallery';
import { BuyBox } from '../components/BuyBox';
export function HeroSection() {
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12 lg:py-16" data-id="element-163">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start" data-id="element-164">
        <div className="w-full" data-id="element-165">
          <ProductGallery data-id="element-166" />
        </div>
        <div className="w-full lg:sticky lg:top-24" data-id="element-167">
          <BuyBox data-id="element-168" />
        </div>
      </div>
    </section>;
}